import * as React from "react";
import { Label } from "components/bootstrap";
const STATE_LABEL = {
  running: "Running",
  completed: "Completed",
  failed: "Failed"
};
const STATE_STYLE = {
  running: "info",
  completed: "default",
  failed: "danger"
};
const RunStateLabel = ({ entry }) => {
  var _a;
  return (
    // `error` is only ever written together with a failed state, so it needs no state check of its own.
    /* @__PURE__ */ React.createElement(Label, { bsStyle: STATE_STYLE[entry.state], uppercase: true, title: (_a = entry.error) != null ? _a : void 0 }, STATE_LABEL[entry.state])
  );
};
export default RunStateLabel;
